import { render, staticRenderFns } from "./questPopover.vue?vue&type=template&id=07b15985"
import script from "./questPopover.vue?vue&type=script&lang=js"
export * from "./questPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports